export default __webpack_public_path__ + "static/media/plodeIcon.66cbe8ad.svg";